module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--5--redeem-65fa6907.png";